export const CHAINING_VIRTUAL_ID = -2
export const CHAINING_EMPTY_SPECIALTY_ID = -1
export const CHAINING_NO_INSERTED_ID = -1

